import React from 'react';
import PropTypes from 'prop-types';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import AccountsCreateWrapper from './AccountsCreateWrapper';

class AccountsCreateContainer extends React.Component {
    render() {
        const { resource, translate } = this.props;

        const breadcrumbs = [
            {
                label: translate('resources.accounts.title'),
                link: '/accounts',
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.accounts.actions.create') } />
                </Header>

                <AccountsCreateWrapper
                    { ...this.props }
                    resource={ resource }
                />
            </div>
        );
    }
}

AccountsCreateContainer.propTypes = {
    history: PropTypes.object.isRequired,
    resource: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
);

export default enhance(AccountsCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/accounts/create/AccountsCreateContainer.js